import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CompanyDetailsSearchModel} from "../company-details-search.model";
import {CompanyDetailsEntityModel} from "../company-details-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-company-details-search-page",
    templateUrl: "./company-details-search-page.component.html",
    providers: [provideSearchModel(CompanyDetailsSearchModel), provideEntityModel(CompanyDetailsEntityModel)]
})
export class CompanyDetailsSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
